import { BaseApi } from '@/services/api/base-api.ts';
import { z } from 'zod';
import zodAttendanceWithApprovalsDto from '@/schemas/attendance/zod-AttendanceWithApprovalsDto.js';
import zodAttendanceSummaryDto from '@/schemas/attendance/zod-AttendanceSummaryDto.js';
import zodAttendanceMissingDto from '@/schemas/attendance/zod-AttendanceMissingDto.js';
import zodAttendanceDto from '@/schemas/attendance/zod-AttendanceDto.js';

/** 근태 활동 추가 요청 바디 */

export type AttendanceSummaryDto = z.infer<typeof zodAttendanceSummaryDto>;

/** 근태 활동 수정 요청 바디 */

export type AttendanceWithApprovalsDto = z.infer<
  typeof zodAttendanceWithApprovalsDto
>;

export type AttendanceMissingDto = z.infer<typeof zodAttendanceMissingDto>;

export type AttendanceDto = z.infer<typeof zodAttendanceDto>;

export class AttendanceDayApi extends BaseApi {
  constructor() {
    super();
  }

  /** 최근 근태 요약 */
  async getSummaryAsync() {
    return this.requestAsync({
      schema: z.optional(zodAttendanceSummaryDto),
      url: `attendance/summary`,
    });
  }

  async getAsync(empNo: number, targetDate: string) {
    return this.requestAsync({
      schema: z.optional(zodAttendanceDto),
      url: 'attendance',
      query: { empNo: empNo, date: targetDate },
    });
  }

  async createAsync(targetDate: string) {
    return this.requestAsync({
      schema: z.optional(zodAttendanceDto),
      method: 'post',
      url: 'attendance',
      query: { date: targetDate },
    });
  }

  async getWithApprovalsAsync(targetDate: string, empNo?: number) {
    const query = empNo
      ? {
          date: targetDate,
          empNo,
        }
      : { date: targetDate };
    return this.requestAsync({
      schema: z.optional(zodAttendanceWithApprovalsDto),
      url: 'attendance/approvals',
      query,
    });
  }

  async getWithApprovalsByIdAsync(attendanceId: number) {
    return this.requestAsync({
      schema: zodAttendanceWithApprovalsDto,
      url: `attendance/${attendanceId}/approvals`,
    });
  }

  async listAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.array(zodAttendanceDto),
      url: `attendances`,
      query: {
        yearMonth: yearMonth,
      },
    });
  }

  async listMissingAttendancesAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.array(zodAttendanceMissingDto),
      url: 'attendances/missing/attendance',
      query: {
        yearMonth: yearMonth,
      },
    });
  }

  async listMissingApplicationsAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.array(zodAttendanceMissingDto),
      url: 'attendances/missing/application',
      query: {
        yearMonth: yearMonth,
      },
    });
  }

  async getCountOfVacationAfterTodayAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.number().optional(),
      url: 'attendances/vacation/count',
      query: {
        yearMonth: yearMonth,
      }
    })
  }
}
